<div class="contenedorform">
  <div class="divleftform">
    <div class="box-container" style="margin-bottom:20px ;"
      *ngIf="formTypeKey.FRM_SOLICITUD_COLECTIVA_TRABAJADOR !== keyFormRequest">
      <h3 class="mt-2">Solicitud {{ dataRequest.typedata.descripcion }}</h3>

      <div class="box-summarytitle">
        <p class="copec-rg-18 title-summary">Estado solicitud:</p>
        <img [src]="getIconStatus()" alt="" style="height: 24px; margin: 5px 0 0 0" />
        <div *ngIf="status_request === 'Con error'" style="display: flex">
          <p style="margin-top: 4px">Acción requerida:</p>
          <button class="correction" (click)="correctFields()">Corregir</button>
        </div>
      </div>

      <p class="copec-lg-14" *ngIf="correction" style="margin-left: 18px">
        Asegúrate de corregir los campos que estén habilitados y que contengan
        este símbolo
        <img src="./assets/icon-summary/warning.svg" alt="correction" style="margin-bottom: 3px" />
      </p>

      <div class="copec-lg-16">
        <table id="details-request" class="details-request"
          [ngStyle]="{ 'margin-left': status_request === 'Con error' ? '18px' : '8px' }">
          <caption></caption>

          <!-- ====================== INFORMACIÓN PERSONAL ====================== -->
          <tr *ngIf="!isObjectEmpty(summary_data.informacion_personal)">
            <th id="personal-inf" class="copec-bold-16 subtitleForm" colspan="2">
              Información personal
            </th>
          </tr>

          <tr *ngFor="let campo of orderedFields.informacion_personal">
            <td class="colorgray col-label">
              <img src="./assets/icon-summary/warning.svg" alt=""
                *ngIf="formTypeKey.FRM_CAMBIO_PLAN !== keyFormRequest && campo.corregir" />
              {{ campo.key.replaceAll('_',' ') }}
            </td>
            <td class="col-value">
              <input [type]="getFieldType(campo.key)"
                *ngIf="formTypeKey.FRM_CAMBIO_PLAN !== keyFormRequest && campo.corregir && correction"
                [name]="template_data.informacion_personal[campo.key].valor"
                [(ngModel)]="template_data.informacion_personal[campo.key].valor"
                (keypress)="onKeyPress($event, campo.key)" />
              <p *ngIf="formTypeKey.FRM_CAMBIO_PLAN !== keyFormRequest && !(campo.corregir && correction)">
                {{ campo.valor }}
              </p>
              <p *ngIf="formTypeKey.FRM_CAMBIO_PLAN === keyFormRequest">{{ campo.valor }}</p>
            </td>
          </tr>

          <!-- ====================== INFORMACIÓN BANCARIA (solo cambio plan) ====================== -->
          <ng-container *ngIf="formTypeKey.FRM_CAMBIO_PLAN === keyFormRequest">
            <tr *ngIf="!isObjectEmpty(summary_data.informacion_bancaria)">
              <th id="bank-inf" class="copec-bold-16 subtitleForm" colspan="2">
                Información Bancaria
              </th>
            </tr>
            <tr *ngFor="let campo of getOrderedFields(summary_data.informacion_bancaria)">
              <td class="colorgray col-label">
                {{ campo.key.replaceAll('_',' ') }}
              </td>
              <td class="col-value">
                <p>{{ campo.valor }}</p>
              </td>
            </tr>
          </ng-container>

          <!-- ====================== BENEFICIARIOS (cuando NO es cambio de plan) ====================== -->
          <ng-container *ngIf="formTypeKey.FRM_CAMBIO_PLAN !== keyFormRequest">

            <!-- ===== Caso especial: AYUDA ESPECIAL TRABAJADOR E HIJO ===== -->
            <ng-container *ngIf="keyFormRequest === formTypeKey.FRM_AYUDA_ESPECIAL_REEMBOLSO">
              <ng-container *ngIf="orderedFields?.beneficiarios?.length">
                <!-- Encabezado único -->
                <tr>
                  <th id="beneficiarie" class="copec-bold-16 subtitleForm" colspan="2">
                    Beneficiario
                  </th>
                </tr>

                <!-- Lista plana de TODOS los campos relacionados a beneficiarios -->
                <tr *ngFor="let campo of orderedFields.beneficiarios">
                  <td class="colorgray col-label">
                    {{ campo.key.replaceAll('_',' ') }}
                  </td>
                  <td class="col-value">
                    <p>
                      {{
                      campo?.valor
                      || template_data?.beneficiarios?.[campo.key]?.valor
                      || summary_data?.beneficiarios?.[campo.key]?.valor
                      || '-'
                      }}
                    </p>
                  </td>
                </tr>
              </ng-container>
            </ng-container>

            <!-- ===== Resto de formularios: mantener la lógica normal ===== -->
            <ng-container *ngIf="keyFormRequest !== formTypeKey.FRM_AYUDA_ESPECIAL_REEMBOLSO">
              <!-- Si viene como arreglo de beneficiarios -->
              <ng-container *ngIf="summary_data?.beneficiarios?.length > 0; else flatBeneficiarios">
                <ng-container *ngFor="let beneficiario of summary_data.beneficiarios; let idx = index">
                  <tr>
                    <th id="beneficiarie" class="copec-bold-16 subtitleForm" colspan="2">
                      Beneficiario {{ idx + 1 }}
                    </th>
                  </tr>
                  <tr *ngFor="let campo of getOrderedFields(beneficiario)">
                    <td class="colorgray col-label">
                      {{ campo.key.replaceAll('_',' ') }}
                    </td>
                    <td class="col-value">
                      <p>{{ campo.valor }}</p>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>

              <!-- Fallback si viniera plano -->
              <ng-template #flatBeneficiarios>
                <ng-container *ngIf="orderedFields?.beneficiarios?.length">
                  <tr>
                    <th id="beneficiarie" class="copec-bold-16 subtitleForm" colspan="2">
                      Beneficiarios
                    </th>
                  </tr>
                  <tr *ngFor="let campo of orderedFields.beneficiarios">
                    <td class="colorgray col-label">
                      {{ campo.key.replaceAll('_',' ') }}
                    </td>
                    <td class="col-value">
                      <p>
                        {{
                        campo?.valor
                        || template_data?.beneficiarios?.[campo.key]?.valor
                        || summary_data?.beneficiarios?.[campo.key]?.valor
                        || '-'
                        }}
                      </p>
                    </td>
                  </tr>
                </ng-container>
              </ng-template>
            </ng-container>

          </ng-container>

          <!-- ====================== BENEFICIARIOS (cambio de plan) ====================== -->
          <ng-container *ngIf="formTypeKey.FRM_CAMBIO_PLAN === keyFormRequest">
            <ng-container *ngFor="let beneficiarios of summary_data.beneficiarios; let i = index">
              <tr *ngIf="!isObjectEmpty(summary_data.beneficiarios)">
                <th id="beneficiarie" class="copec-bold-16 subtitleForm" colspan="2">
                  Beneficiario {{ i + 1 }}
                </th>
              </tr>

              <tr *ngFor="let campo of getOrderedFields(beneficiarios)">
                <td class="colorgray col-label">
                  {{ campo.key.replaceAll('_',' ') }}
                </td>
                <td class="col-value">
                  <p>{{ campo.valor }}</p>
                </td>
              </tr>

              <!-- Preexistencias por RUT -->
              <ng-container *ngFor="let x of summary_data.preExistences">
                <ng-container *ngIf="x.identification === beneficiarios['rut'].valor">
                  <tr>
                    <td class="colorgray col-label">Pre-Existencias:</td>
                    <td class="col-value">{{ x.isPreExistence ? 'SI' : 'NO' }}</td>
                  </tr>
                  <ng-container *ngFor="let prees of x.detailPreExistences">
                    <ng-container *ngIf="prees.datePreExistence.length !== 0">
                      <tr>
                        <td class="colorgray col-label">Fecha Preexistencia</td>
                        <td class="col-value">{{ prees.datePreExistence }}</td>
                      </tr>
                      <tr>
                        <td class="colorgray col-label">Detalle:</td>
                        <td class="col-value">{{ prees.description }}</td>
                      </tr>
                    </ng-container>
                  </ng-container>
                </ng-container>
              </ng-container>
            </ng-container>
          </ng-container>

          <!-- ====================== DIRECCIÓN ====================== -->
          <tr *ngIf="!isObjectEmpty(summary_data.direccion)">
            <th id="add-inf" class="copec-bold-16 subtitleForm" colspan="2">
              Dirección de envío
            </th>
          </tr>

          <tr *ngFor="let campo of orderedFields.direccion">
            <td class="colorgray col-label">
              <img src="./assets/icon-summary/warning.svg" alt="" *ngIf="campo.corregir" />
              {{ campo.key.replaceAll('_',' ') }}
            </td>
            <td class="col-value">
              <input [type]="getFieldType(campo.key)" *ngIf="campo.corregir && correction"
                [name]="template_data.direccion[campo.key].valor" [(ngModel)]="template_data.direccion[campo.key].valor"
                (keypress)="onKeyPress($event, campo.key)" />
              <p *ngIf="!(campo.corregir && correction)">{{ campo.valor }}</p>
            </td>
          </tr>

          <!-- ====================== INFO COMPLEMENTARIA ====================== -->
            <ng-container *ngIf="formTypeKey.FRM_SALUD_DENTAL !== keyFormRequest">
          <tr *ngIf="!isObjectEmpty(summary_data.informacion_adicional)">
            <th id="add-inf" class="copec-bold-16 subtitleForm" colspan="2">
              Información complementaria
            </th>
          </tr>

          <tr *ngFor="let campo of orderedFields.informacion_adicional">
            <td class="colorgray col-label">
              <img src="./assets/icon-summary/warning.svg" alt=""
                *ngIf="formTypeKey.FRM_CAMBIO_PLAN !== keyFormRequest && campo.corregir" />
              {{ campo.key.replaceAll('_',' ') }}
            </td>
            <td class="col-value">
              <input [type]="getFieldType(campo.key)"
                *ngIf="formTypeKey.FRM_CAMBIO_PLAN !== keyFormRequest && campo.corregir && correction && campo.key !== 'Usuarios'"
                [name]="template_data.informacion_adicional[campo.key].valor"
                [(ngModel)]="template_data.informacion_adicional[campo.key].valor"
                (keypress)="onKeyPress($event, campo.key)" />

              <button id="btn_modificar_usuarios" name="btn_modificar_usuarios"
                *ngIf="formTypeKey.FRM_CABANA_EL_QUISCO === keyFormRequest && correction && campo.key === 'Usuarios'"
                (click)="modificar(template_data.informacion_adicional[campo.key].valor)" 
                class="btn btn-primary btn-sm">Modificar lista de personas</button>

              <p *ngIf="formTypeKey.FRM_CAMBIO_PLAN !== keyFormRequest && !(campo.corregir && correction)">
                {{ valueField(campo.valor) }}
              </p>
              <p *ngIf="formTypeKey.FRM_CAMBIO_PLAN === keyFormRequest">{{ campo.valor }}</p>
            </td>
          </tr>
          </ng-container>
        </table>
      </div>

      <p class="copec-lg-14" *ngIf="correction" style="margin-left: 18px; margin-bottom: -10px; color: #165cdf">
        Si tu archivo presenta corrección, recuerda subir un nuevo documento.
      </p>

      <div *ngIf="duplicateFileError" class="copec-lg-14"
        style="color: red; margin-left: 18px; margin-bottom: -10px; margin-top: 10px;">
        {{ duplicateFileError }}
      </div>

      <div *ngIf="summary_data.archivos.length > 0">
        <app-download-file [summaryData_archivos]="summary_data.archivos" [statusRequest]="status_request"
          [correction]="false" [formulario]="keyFormRequest">
        </app-download-file>
      </div>
    </div>

    <div id="solicitud-colectiva" *ngIf="formTypeKey.FRM_SOLICITUD_COLECTIVA_TRABAJADOR === keyFormRequest"
      class="box-container">
      <h3 class="mt-2">Solicitud {{ dataRequest.typedata.descripcion }}</h3>
      <div class="copec-lg-16">
        <app-summary-medical-credit [selectedOption]="status_request" [summarydata]="summary_data"
          [id_solicitud]="summary_data.idrequest">
        </app-summary-medical-credit>
      </div>
      <div *ngIf="summary_data.archivos.lenght > 0">
        <app-download-file [summaryData_archivos]="summary_data.archivos" [statusRequest]="status_request"
          [correction]="false" [formulario]="keyFormRequest">
        </app-download-file>
      </div>
    </div>

    <div class="footer"
      *ngIf="correction || (formTypeKey.FRM_SOLICITUD_COLECTIVA_TRABAJADOR === keyFormRequest && status_request === 'Enviada')">
      <button class="cancel" (click)="cancelEdit()">Cancelar</button>
      <button [disabled]="isLoading" (click)="onSubmit()" class="correct">Enviar actualización</button>
    </div>
  </div>

  <div class="divrightform">
    <div class="divfile"
      *ngIf="(correction && filesToCorrect()) || (formTypeKey.FRM_SOLICITUD_COLECTIVA_TRABAJADOR === keyFormRequest && status_request === 'Enviada')"
      class="mt-4 mb-4">
      <div class="mb-3">
        <h4>Carga de documentos</h4>
        <div>
          <app-upload-file (emmiter_archivos_cargados)="save_file($event)" [count_files]="emptyFiles">
          </app-upload-file>
        </div>
      </div>
    </div>

    <div class="divhistoric" *ngIf="formTypeKey.FRM_SOLICITUD_COLECTIVA_TRABAJADOR !== keyFormRequest">
      <app-history [name_benefit]="dataRequest.typedata.descripcion" [name_employee]="name_employee">
      </app-history>
    </div>
  </div>
</div>

<div class="modal-overlay" *ngIf="popupModificacionPersonas">
  <div class="modal-gallery-content">
    
    <div class="modal-header">
      <h2>Listado de personas</h2>
      <span class="close-main" (click)="cerrarModal()">&times;</span>
    </div>

    <div class="modal-body">
      <div *ngFor="let usuario of usuarios; let i = index" class="input-row">
        <span class="row-number">{{ i + 1 }}.</span>
        <div class="input-container">
          <input 
            type="text" 
            class="form-control" 
            [(ngModel)]="usuario.nombre" 
            placeholder="Edita el nombre">
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn-primary" (click)="grabar()">Guardar</button>
    </div>

  </div>
</div>